import React, { FC } from "react"

import { Space } from "antd"

import ManualSelect from "./selects/ManualSelect"
import { IAttributionItem } from "../../../../../../app/types/filter"


interface IAttributionProps {
    items: IAttributionItem[]
}

const Attribution: FC<IAttributionProps> = ({ items }) => {
    const isDashboardAttributes = items.some((el)=>el.selectValues.some((element)=>element.id === "blocks") )
    return (
        <Space direction="horizontal" className="params__attr-container">
            {
                items.map((item, index) => (
                    <ManualSelect
                        isDashboardAttributes={isDashboardAttributes}
                        key={index}
                        id={item.id}
                        name={item.name}
                        selectValues={item.selectValues}
                        description={item.description}
                        icon={item.icon}
                    />
                ))
            }
        </Space>
    )
}

export default Attribution
